import React from 'react';
import { Generic, RecordState, setRecordId, setRecordState } from "../../Store/Generic/GenericSlice";
import { TableBodyProps } from "./Table.interface";
import { useDispatch } from "react-redux";


const TableBody = <T, K extends keyof T>({ data, columns }: TableBodyProps<T, K>): JSX.Element => {
    const dispatch = useDispatch();
    const handleRecordState = (row: Generic, record: RecordState) => {
        dispatch(setRecordId(row['id']))
        dispatch(setRecordState(record))
    }
    const rows = data?.filter((item: any) => item.display === true).map((row, index) => {
        return (
            <tr key={`row-${index}`}>
                <td>{index + 1}</td>
                {columns.map((column, index2) => {
                    return (<td key={`column-${index2}`}>
                        {row[column.name] as React.ReactNode}
                    </td>
                    );
                })
                }
                <td className="text-center">
                    <button className="btn" onClick={(e) => { handleRecordState(row as Generic, 'VIEW') }}>
                        <i className='dripicons-preview' data-toggle="modals" id='view_details'></i>
                    </button>
                    <button className="btn" onClick={() => { handleRecordState(row as Generic, 'EDIT') }}><i className='dripicons-document-edit ml-2 mr-2' id='edit_details'></i></button>
                    <button className="btn" onClick={() => { handleRecordState(row as Generic, 'DELETE') }}><i className='dripicons-trash' id="delete_details"></i></button>
                </td >
            </tr >
        )
    });
    return (
        <tbody>{rows}</tbody>
    )
};
export default TableBody;